/**
 * This dropdown is used in the Change Story post type archive
 */
export default {
  init: function()
  {
    if (!$('.archive-changestory-landing').length)
    {
      return;
    }
    
    this.changeDropDown();
  },
  changeDropDown: function() {

    //Pinned header 
    function offset(el) {
        var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
    var domPinnedHeader = document.getElementById("startSticky");
    var domPinnedRect = document.documentElement.scrollTop || document.body.scrollTop;
    var headerOffset = offset(domPinnedHeader); 
    var topOffset = headerOffset.top;
    //console.log(domPinnedRect);
    function pinMainNav(top, offset) {
      var stickyStart = offset;
      if (top > stickyStart) {
        $('.archive-changestory-landing .header').addClass('sticky');
        $('.archive-changestory-landing .floating-header').addClass('sticky');
      } else {
        $('.archive-changestory-landing .header').removeClass('sticky');
        $('.archive-changestory-landing .floating-header').removeClass('sticky');
      }
    }
    pinMainNav(domPinnedRect, topOffset);
    window.addEventListener('scroll', function() {
      domPinnedRect = document.documentElement.scrollTop || document.body.scrollTop;
      headerOffset = offset(domPinnedHeader); 
      topOffset = headerOffset.top;
      pinMainNav(domPinnedRect, topOffset);
    });

    $(".header-filters .dropdown .btn-secondary").click(function(event)
    {
      var getHeight = $(this).outerHeight();
      $(".header-filters .dropdown").toggleClass("show");
      $(".header-filters .dropdown-menu").toggleClass("show");
      if ($(".header-filters .dropdown-menu").hasClass("shw")) {
        $(".header-filters .dropdown-menu").css("position: absolute; transform: translate3d(0px, 38px, 0px); top: 0px; left: 0px; will-change: transform;")
      } else {
        $(".header-filters .dropdown-menu").removeAttr('style');
      }
    });

    var params = new URLSearchParams(window.location.search);
    if (params.has('_sft_change_story')) {
      $('.header-filters .dropdown-list .dropdown__link.default_link').removeClass('active');
      var changeStoryParam = params.get('_sft_change_story');
      var activeListItem = $('.header-filters .dropdown-list .dropdown__link.'+changeStoryParam+'');
      $(activeListItem).addClass('active');
      var getActiveText =  $(activeListItem).text();
      $('.header-filters .dropdown-list .dropdown-toggle.btn-secondary .text').text(getActiveText);
      if (window.matchMedia('(max-width: 767px)').matches) {
        var elmntBtn = document.getElementById("filterscroll");
        elmntBtn.scrollIntoView();
      }
    }
    $('.opacity-load').removeClass('no-load');
    /*
    for (const param of params) {
      console.log(param)
    }
    */
  }

}